import React from 'react'

const Transactions = () => {
  return (
    <div>Transactions Page</div>
  )
}

export default Transactions;